module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._v(" " + _vm._s(_vm.data.symbol) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "user-widget"
  }, _vm._l((_vm.data.users), function(user) {
    return _c('img', {
      key: user.id,
      staticClass: "user-widget_image",
      attrs: {
        "src": _vm.get_avatar_image(user.avatar_tag),
        "title": user.email
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63982f4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SymbolCell.vue
// module id = 138
// module chunks = 0